// SabarmathyDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import sabarmathydoc from '../../../../assets/images/Doctorsimages/sarbarmathydr.png' // Placeholder for Dr. Sabarmathy's image
import favicon from "../../..//../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


const SabarmathyDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. Sabarmathy | Best Dentist & Aesthetic Doctor in Pondicherry, India | Smile & Skin Specialist";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Sabarmathy (BDS, Fellowship in Cosmetic Science), a leading Dentist and Aesthetic Physician in Pondicherry. Expert in dental care, smile makeovers, and advanced aesthetic treatments with a focus on natural beauty and holistic patient well-being."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "dentist in Pondicherry, facial aesthetics Pondicherry, aesthetic doctor in Pondicherry, dental and aesthetic physician Pondicherry, best dentist doctors in Pondicherry, top dentist in Pondicherry, best aesthetic doctors in Pondicherry, leading aesthetic doctor near me, cosmetic dentist Pondicherry, dentist and aesthetic expert Pondicherry, smile makeover Pondicherry, natural beauty enhancement Pondicherry, dental clinic Pondicherry, dental care and skin rejuvenation Pondicherry, aesthetic treatments Pondicherry, best cosmetic dentist in Pondicherry, skin health specialist Pondicherry, aesthetic physician for skin in Pondicherry, Dental Clinic Near Me, dentist for smile design Pondicherry, teeth cleaning Pondicherry, Dental Near You, Teeth Whitening & Aligners, Dental Near me"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctor/dr-sabarmathy-dentist-aesthetic-pondicherry");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctor/dr-sabarmathy-dentist-aesthetic-pondicherry");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  // Add PDF-specific class to container
  container.classList.add('veenadoc-pdf-mode');

  // Store original styles
  const originalStyles = new Map();

  // Temporarily modify styles for PDF capture
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  // Fix hero section height for PDF
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  // Ensure images are fully loaded and visible
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  // Wait a moment for styles to apply
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore original styles
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Define margins for the PDF
      const marginLeft = 10; // 10mm gap on the left
      const marginRight = 10; // 10mm gap on the right to maintain symmetry and prevent cutting
      const availableWidth = pdfWidth - marginLeft - marginRight;

      // Calculate scaling factor to fit the canvas content within the available width
      const scaleFactor = availableWidth / canvasWidth;

      // Apply the scale factor to both width and height to maintain aspect ratio
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      // Calculate the number of pages needed for vertical content overflow
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        // Add image to PDF, using marginLeft for the x coordinate
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Sabarmathy_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Sabarmathy</span>
                  <span className="veenadoc-title-credentials">(BDS, Fellowship in Cosmetic Science & Semi Permanent Makeup)</span>
                  <span className="veenadoc-title-location">Pondicherry</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <div className="veenadoc-hero-description">
<p>
  Dr. Sabarmathy brings 6+ years of expertise in integrating advanced dentistry with aesthetic medicine. Her personalized approach delivers transformative smile makeovers and skin rejuvenation treatments, enhancing natural beauty and promoting lasting wellness for patients across Pondicherry.
</p>

</div>

                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={sabarmathydoc} alt="Dr. Sabarmathy – Consultant Dentist & Aesthetic Physician in Pondicherry" className="veenadoc-doctor-image" title='Dr. Sabarmathy | Best Dentist & Aesthetic Doctor for Smile & Skin in Pondicherry' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* About Dr. Sabarmathy */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Sabarmathy</h2>
                  <p>
                    Dr. Sabarmathy, a distinguished Dentist and Aesthetic Physician, brings a unique blend of expertise to the H-Cura Multispeciality Clinic in Pondicherry. With a strong foundation in dental science and specialized training in cosmetic science and semi-permanent makeup, Dr. Sabarmathy offers an integrated approach to facial aesthetics and overall patient well-being. Her practice is rooted in providing personalized, evidence-based care that not only addresses specific concerns but also promotes lasting results and enhances natural beauty. Patients seeking the best dentist doctors in Pondicherry or the best aesthetic doctors in Pondicherry will find her comprehensive and ethical approach particularly appealing.
                  </p>
                  <p>
                    At H-Cura, Dr. Sabarmathy’s mission is to combine the precision of advanced dental procedures with the artistry of aesthetic treatments. She believes that a healthy, radiant smile is intrinsically linked to overall facial harmony and skin vitality. Her dedication ensures that every patient receives safe, gentle, and transformative care, making her a highly sought-after professional in the region.
                  </p>
                </div>

                {/* Professional Qualifications & Educational Background */}
                <div className="veenadoc-article-block">
                  <h2>Professional Qualifications & Educational Background</h2>
                  <p>
                    Dr. Sabarmathy’s academic journey began with a Bachelor of Dental Surgery (BDS) from MAHE Institute of Dental Science and Hospital, affiliated with Pondicherry University. This rigorous training provided her with a comprehensive understanding of oral health, dental anatomy, and a wide array of dental procedures. Driven by a passion for holistic facial aesthetics, she further specialized by completing a Fellowship in Cosmetic Science & Semi Permanent Makeup from the International Advanced Aesthetic Science and Nutrition Academy (IAASN) in Tamil Nadu. This advanced qualification has equipped her with cutting-edge techniques and a profound understanding of aesthetic principles.
                  </p>
                  <p>
                    Her practical experience includes a crucial internship at Mahatma Gandhi Postgraduate Institute of Dental Science, a Government of Pondicherry institution under Pondicherry University, where she honed her clinical skills in a diverse patient setting. Additionally, she served as a Special Trainee at Government Villupuram Medical College and Hospital in Villupuram, Tamil Nadu, gaining invaluable exposure to various medical and dental cases. These foundational experiences have shaped her into a well-rounded and compassionate practitioner, capable of delivering exceptional care as both a dentist and an aesthetic physician. With over 6 years of clinical experience, Dr. Sabarmathy has a proven track record of excellence in both hospital and private practice settings.
                  </p>
                </div>


                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS, Fellowship in Cosmetic Science & Semi Permanent Makeup</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">6+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Dentistry & Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Pondicherry</span>
                    </div>
                  </div>
                </div>
                {/* Clinical Experience & Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Experience & Expertise</h2>
                  <p>
                    With more than 6 years of extensive clinical experience, Dr. Sabarmathy has cultivated a rich background in diverse dental and aesthetic environments. Her career includes significant roles at esteemed institutions such as Dr. Ramesh Babu Dental Clinic, PT Smile Gallery Dental Gallery, and PRABAS VCARE. At these centers, she managed a wide spectrum of cases, from routine dental check-ups and restorative dentistry to complex cosmetic dental procedures and advanced aesthetic treatments. This varied experience has allowed her to develop a keen eye for detail and a comprehensive understanding of patient needs, making her adept at crafting highly individualized treatment plans.
                  </p>
                  <p>
                    Her experience spans general dentistry, where she focused on preventative care, diagnosis, and treatment of oral diseases, as well as cosmetic dentistry, where she helped patients achieve their ideal smiles. Simultaneously, her work in aesthetic clinics allowed her to apply her fellowship training, delivering results that enhance natural beauty and improve skin health. This dual expertise positions Dr. Sabarmathy as a unique and invaluable asset to H-Cura Multispeciality Clinic, particularly for patients seeking integrated solutions from a skilled dentist and a proficient aesthetic physician.
                  </p>
                </div>

                {/* Role at H-Cura & Practice Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>Role at H-Cura & Practice Philosophy</h2>
                  <p>
                    In her pivotal role as a Consultant Dentist and Aesthetic Physician at H-Cura Multispeciality Clinic, Dr. Sabarmathy integrates two critical aspects of patient care:
                  </p>
                  <ul>
                    <li><strong>Comprehensive Dental Care:</strong> Offering advanced diagnostic and therapeutic services for optimal oral health, including preventative, restorative, and cosmetic dentistry.</li>
                    <li><strong>Advanced Aesthetic Treatments:</strong> Providing state-of-the-art procedures for skin rejuvenation and facial enhancement, all designed to complement her dental expertise.</li>
                  </ul>
                  <p>
                    Dr. Sabarmathy’s treatment philosophy is beautifully encapsulated in her personal quote: “My treatment philosophy focuses on providing personalized, evidence-based care that addresses the root cause and promotes lasting results. My approach integrates science and artistry to enhance natural beauty while maintaining skin health and balance. Patient comfort, trust, and ethical care form the foundation of every treatment I provide.” She firmly believes that true beauty and health are interconnected. Therefore, her treatment plans meticulously address the underlying causes of concerns, whether they are dental issues affecting a smile or skin conditions impacting facial aesthetics, while simultaneously delivering visible and lasting improvements through her aesthetic and dental interventions.
                  </p>
                </div>

                {/* Areas of Expertise at H-Cura & Advanced Dental Treatments Offered */}
                <div className="veenadoc-article-block">
                  <h2>Areas of Expertise & Advanced Dental Treatments Offered</h2>
                  <p>
                    Dr. Sabarmathy's core areas of specialization at H-Cura Multispeciality Clinic are designed to provide a seamless integration of dental and aesthetic services:
                  </p>
                  <ul>
                    <li><strong>Dental Services:</strong> General dentistry (check-ups, fillings, extractions), preventative dental care (cleanings, fluoride treatments), restorative dentistry (crowns, bridges), cosmetic dentistry (veneers, teeth whitening, smile makeovers), gum disease management, and oral hygiene education.</li>
                    <li><strong>Aesthetic Treatments:</strong> Advanced skin rejuvenation therapies, anti-aging solutions, pigmentation correction, non-surgical facial enhancements, skin health and balance programs, and bespoke aesthetic consultations.</li>
                    <li><strong>Integrated Facial Aesthetics:</strong> Comprehensive treatment plans that combine dental and aesthetic procedures to achieve harmonious facial proportions, enhanced smiles, improved skin quality, and overall facial balance. This includes addressing concerns like gummy smiles, lip aesthetics in relation to teeth, and overall facial symmetry.</li>
                    <li><strong>Patient Education & Wellness:</strong> Lifestyle counseling, nutritional guidance for oral and skin health, and personalized home care regimens to maintain treatment results and promote long-term well-being.</li>
                  </ul>
                  <p>
                    Each of these categories is fully integrated within H-Cura’s advanced infrastructure, ensuring a synergistic approach between dentistry, cosmetology, and wellness consultation under the expert guidance of Dr. Sabarmathy, who is both a skilled dentist and an accomplished aesthetic physician.
                  </p>
                  <div className="veenadoc-article-block">
                       <h2>Advanced Dental Treatments Offered</h2>
                  </div>
                 
                  <ul>
                    <li><strong>Cosmetic Smile Makeovers:</strong> Utilizing veneers, bonding, and teeth whitening to transform smiles, addressing issues like discoloration, gaps, and irregularities. Her artistic eye ensures natural-looking, radiant results.</li>
                    <li><strong>Restorative Dentistry:</strong> Providing durable and aesthetically pleasing solutions for damaged or missing teeth, including composite fillings, crowns, and bridges, restoring function and appearance.</li>
                    <li><strong>Preventative & General Dentistry:</strong> Emphasizing routine check-ups, professional cleanings, and patient education on oral hygiene to prevent dental problems and maintain long-term oral health.</li>
                    <li><strong>Gum Health Management:</strong> Diagnosing and treating gum diseases to ensure a healthy foundation for teeth, crucial for both oral health and the overall aesthetic of a smile.</li>
                    <li><strong>Digital Smile Design:</strong> Employing advanced technology to plan and visualize smile transformations, allowing patients to preview their new smile before treatment begins, ensuring satisfaction with their dentist.</li>
                  </ul>
                  <p>
                    These treatments are meticulously planned to align with each patient’s unique needs and aesthetic goals, reinforcing her reputation as one of the best dentist doctors in Pondicherry.
                  </p>
                </div>

                {/* Advanced Aesthetic Treatments Offered */}
                <div className="veenadoc-article-block ">
                  <h2>Advanced Aesthetic Treatments Offered</h2>
                  <p>
                    Dr. Sabarmathy's fellowship in Cosmetic Science enables her to offer sophisticated aesthetic treatments that complement her dental services, providing a truly holistic facial enhancement experience:
                  </p>
                  <ul>
                    <li><strong>Advanced Skin Rejuvenation:</strong> Offering personalized protocols for anti-aging, pigmentation correction, and improving skin texture and tone, utilizing scientifically backed methods to promote healthy, radiant skin.</li>
                    <li><strong>Non-Surgical Facial Enhancements:</strong> Providing consultations and treatments aimed at improving facial contours and harmony, ensuring that the aesthetic results are natural and balanced with the patient's features.</li>
                    <li><strong>Acne & Scar Management:</strong> Developing tailored treatment plans to address active acne and reduce the appearance of post-acne scars, leading to clearer and smoother skin.</li>
                    <li><strong>Skin Hydration & Glow Therapies:</strong> Customizing treatments to deeply hydrate the skin, improve its luminosity, and enhance overall skin health, contributing to a youthful and vibrant aesthetic.</li>
                  </ul>
                  <p>
                    These cutting-edge aesthetic treatments are delivered with precision and an artistic touch, ensuring patients achieve their desired look while maintaining natural beauty and skin health, solidifying her position among the best aesthetic doctors in Pondicherry.
                  </p>
                </div>

                {/* Why Patients Choose Her at H-Cura */}
                <div className="veenadoc-article-block">
                  <h2>Why Patients Choose Her at H-Cura</h2>
                  <p>
                    Patients in search of a top-tier dentist or an expert aesthetic doctor in Pondicherry consistently choose Dr. Sabarmathy at H-Cura Multispeciality Clinic for several compelling reasons:
                  </p>
                  <ul>
                    <li><strong>Dual Expertise:</strong> She is one of the few practitioners in the region with comprehensive training and extensive experience in both dentistry and advanced aesthetic science, offering a unique, integrated approach to facial enhancement.</li>
                    <li><strong>Holistic & Patient-Centered Care:</strong> Dr. Sabarmathy's philosophy emphasizes treating the whole person, addressing underlying causes, and ensuring patient comfort, trust, and ethical care in every dental and aesthetic procedure.</li>
                    <li><strong>Integrated Clinic Environment:</strong> Working within H-Cura Multispeciality Clinic, patients benefit from seamless access to various specialties, advanced diagnostics, and coordinated care, all under one roof.</li>
                    <li><strong>Artistry & Precision:</strong> Her approach combines scientific rigor with an artistic sensibility, ensuring that all treatments, whether a smile makeover or a skin rejuvenation procedure, enhance natural beauty with precision and exquisite results.</li>
                    <li><strong>Personalized Treatment Plans:</strong> Dr. Sabarmathy takes the time to understand each patient's unique needs and goals, crafting bespoke treatment plans that deliver optimal and lasting outcomes. Her ability to combine dentist and aesthetic skills makes her invaluable.</li>
                    <li><strong>Communication & Trust:</strong> Patients appreciate her clear, empathetic communication style, which fosters a sense of trust and ensures they are fully informed and comfortable throughout their treatment journey. She is truly among the best dentist doctors in Pondicherry and best aesthetic doctors in Pondicherry.</li>
                  </ul>
                </div>

              

                {/* Patient Testimonials */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Reviews</h2>
                  <p>
                    Patients who consult Dr. Sabarmathy appreciate her empathetic nature, careful listening, and detailed analysis. Many reviews describe her as approachable, professional, and highly effective in providing treatments that deliver visible and long-lasting results.
                  </p>
                  <p>
                    Her strong reputation for combining medical knowledge with personal care has made her one of the most trusted names in dentistry and aesthetics in Pondicherry.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Sabarmathy for Complete Wellness</h2>
                  <p>
                    Choosing Dr. Sabarmathy means selecting a doctor who is committed to your complete health and well-being. She provides the assurance of safe treatments, the expertise of modern dental and aesthetic science, and the compassion of a holistic healer.
                  </p>
                  <p>
                    For anyone searching for the best dentist and aesthetic doctor in Pondicherry, or specifically looking for a top dentist for smile and skin treatments, Dr. Sabarmathy is the doctor who brings together trust, expertise, and results.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with healthier lives, radiant smiles, beautiful skin, and renewed confidence.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "My treatment philosophy focuses on providing personalized, evidence-based care that addresses the root cause and promotes lasting results. My approach integrates science and artistry to enhance natural beauty while maintaining skin health and balance. Patient comfort, trust, and ethical care form the foundation of every treatment I provide."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Sabarmathy's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing the root cause of illness. This patient-centric approach has positioned her among the best holistic dentists and aesthetic doctors in Pondicherry, where she provides customised treatments for individuals of all age groups.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Pondicherry</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Sabarmathy's personalized approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'} // Assuming same contact number
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'} // Assuming same contact number
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default SabarmathyDoc
